import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Cliente, ClienteResumen, FiltroBusquedaClientes } from '../models/cliente';
import { Bonocliente } from '../models/bonocliente';
import { FinanciacionResumenDTO } from '../models/financiacion';
import { Bonomove } from '../models/bonomove';
import { EventResumenCliente } from '../models/evento';
import { DataCombo } from '../models/combo';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {

  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.url + 'cliente/';
  }

  getClientesByFilter(filtro: FiltroBusquedaClientes): Observable<ClienteResumen[]> {
    return this.http.post<ClienteResumen[]>(this.url, filtro);
  }

  getClientesCombo(tiendaId: number): Observable<DataCombo[]> {
    let urlcom = this.url + "combo/" + tiendaId;
    return this.http.get<DataCombo[]>(urlcom);
  }

  getById(id: number): Observable<Cliente> {
    let urlcom = this.url + id;
    return this.http.get<Cliente>(urlcom);
  }

  update(id: number, data: Cliente): Observable<Cliente> {
    let urlcom = this.url + id;
    return this.http.put<Cliente>(urlcom, data);
  }

  save(data: Cliente): Observable<Cliente> {
    let urlcom = this.url + "register/";
    return this.http.post<Cliente>(urlcom, data);
  }

  delete(id: number): Observable<any> {
    let urlcom = this.url + id;
    return this.http.delete(urlcom);
  }

  activate(id: number): Observable<Cliente> {
    let urlcom = this.url + "activate/" + id;
    return this.http.put<Cliente>(urlcom, null);
  }

  getBonoclientesCliente(idCliente: number): Observable<Bonocliente[]> {
    let urlcom = this.url + idCliente + "/bonoclientes";
    return this.http.get<Bonocliente[]>(urlcom);
  }

  getBonosEconomicosCliente(idCliente: number): Observable<Bonocliente[]> {
    let urlcom = this.url + idCliente + "/bonos-economicos";
    return this.http.get<Bonocliente[]>(urlcom);
  }

  getFinanciacionesCliente(id: number): Observable<FinanciacionResumenDTO[]> {
    let urlcom = this.url + id + "/financiaciones";
    return this.http.get<FinanciacionResumenDTO[]>(urlcom);
  }

  getBonomovesCliente(id: number): Observable<Bonomove[]> {
    let urlcom = this.url + id + "/bonomoves";
    return this.http.get<Bonomove[]>(urlcom);
  }

  getEventosCliente(id: number): Observable<EventResumenCliente[]> {
    let urlcom = this.url + id + "/events";
    return this.http.get<EventResumenCliente[]>(urlcom);
  }

  // creacion de formulario para usar desde diferentes puntos
  buildForm(): any[] {
    return [
      { name: 'id', type: 'hidden' },
      { name: 'name', label: 'campos.clientes.name', type: 'text', required: true },
      { name: 'email', label: 'campos.clientes.email', type: 'text', required: false, class: 'col-sm-4' },
      { name: 'dni', label: 'campos.clientes.dni', type: 'text', required: false, class: 'col-sm-4' },
      { name: 'movil', label: 'campos.clientes.movil', type: 'number', required: false, class: 'col-sm-4' },
      { name: 'address', label: 'campos.clientes.direccion', type: 'text', required: false, class: 'col-sm-9' },
      { name: 'cdPostal', label: 'campos.clientes.cp', type: 'number', required: false, class: 'col-sm-3' },
      { name: 'text', label: 'campos.clientes.observaciones', type: 'textarea', required: false },
    ];
  }

}
